/**
 * Права модуля «Графики». Коды дублируются с бэком вручную, посимвольно —
 * см. Rost.Api/Security/Authorization/Functionality.cs
 */
export default {
    /**
     * Смотреть оба графика может любой сотрудник — отдельного права нет, достаточно
     * быть внутренним пользователем (не аутсорсером, агентом или клиентом).
     * Править Табель План — spending WORKLOAD_EDIT (свой отдел) / WORKLOAD_EDIT_ALL (все).
     */
    SCHEDULES_READ: "INTERNAL_USER_ACCESS",
};
